import { LoadingOverlay } from '@mantine/core';
import { createContext, useState, useCallback, ReactNode } from 'react';

interface LoaderContextType {
  showLoader: (message: string) => void;
  hideLoader: () => void;
}

export const LoaderContext = createContext<LoaderContextType | undefined>(undefined);

interface LoaderState {
  visible: boolean;
  message: string;
}

const GlobalLoaderProvider = ({ children }: { children: ReactNode }) => {
  const [loaderState, setLoaderState] = useState<LoaderState>({ visible: false, message: '' });

  const showLoader = useCallback((message: string) => {
    setLoaderState({ visible: true, message });
  }, []);

  const hideLoader = useCallback(() => {
    setLoaderState({ visible: false, message: '' });
  }, []);

  const value = { showLoader, hideLoader };

  return (
    <LoaderContext.Provider value={value}>
      <LoadingOverlay
        visible={loaderState.visible}
        overlayProps={{ radius: 'sm', blur: 2 }}
        zIndex={1000}
      />
      {children}
    </LoaderContext.Provider>
  );
};

export default GlobalLoaderProvider;
